module.exports = __webpack_public_path__ + "img/4.e9b775b2.png";